import Vue from 'vue'
import Vuex from 'vuex'

import Store from "@/store"
import Router from "@/router"

import Auth from './auth'

import MProfiles from '@/modules/mprofiles/module'
import MConfigs from '@/modules/mconfigs/module'
import MConfigEditor from '@/modules/redactor/module'
import MInbox from '@/modules/minbox/module'
import MLocalization from '@/modules/mlocalization/module'
import MPackages from '@/modules/mpackages/module'
import Mmaps from '@/modules/mmaps/module'
import Maudiences from '@/modules/maudiences/module'
import Mdeploy from '@/modules/mdeploy/module'
import Mcache from '@/modules/mcache/module'
import Minfo from '@/modules/minfo/module'
import Mpermissions from '@/modules/mpermissions/module'
import Muiutils from '@/modules/muiutils/module'
import Mutils from '@/modules/mutils/module'

import StoreTalk from "@/modules/redactor/store/StoreTalk";
import StoreLevel from "@/modules/redactor/store/StoreLevel";
import StoreQuest from "@/modules/redactor/store/StoreQuest";
import StoreDiscovery from "@/modules/redactor/store/StoreDiscovery";
import StoreCurrency from "@/modules/redactor/store/StoreCurrency";
import StoreCurrencyKind from "@/modules/redactor/store/StoreCurrencyKind";
import StoreCurrencyGroup from "@/modules/redactor/store/StoreCurrencyGroup";
import StoreTutorial from "@/modules/redactor/store/StoreTutorial";
import StoreExchange from "@/modules/redactor/store/StoreExchange";
import StoreSetting from "@/modules/redactor/store/StoreSetting";
import StorePrompt from "@/modules/redactor/store/StorePrompt";
import StoreFirefly from "@/modules/redactor/store/StoreFirefly";
import StoreFireflyV2 from "@/modules/redactor/store/StoreFireflyV2";
import StoreReward from "@/modules/redactor/store/StoreReward";
import StoreRecipe from "@/modules/redactor/store/StoreRecipe";
import StoreWorldRegion from "@/modules/redactor/store/StoreWorldRegion";
import StoreWorldRegionTerritory from "@/modules/redactor/store/StoreWorldRegionTerritory";
import StoreSwamp from "@/modules/redactor/store/StoreSwamp";
import StoreWorkerTeam from "@/modules/redactor/store/StoreWorkerTeam";
import StoreChallenge from "@/modules/redactor/store/StoreChallenge";

import StoreItem from "@/modules/redactor/store/StoreItem";
import StoreItemKind from "@/modules/redactor/store/StoreItemKind";
import StoreItemGroup from "@/modules/redactor/store/StoreItemGroup";
import StoreSmartOffer from "@/modules/redactor/store/StoreSmartOffer";
import StoreItemAddon from "@/modules/redactor/store/StoreItemAddon";
import StoreItemOffer from "@/modules/redactor/store/StoreItemOffer";
import StoreItemOrder from "@/modules/redactor/store/StoreItemOrder";
import StoreItemShop from "@/modules/redactor/store/StoreItemShop";
import StoreItemRecipe from "@/modules/redactor/store/StoreItemRecipe";
import StoreItemCluster from "@/modules/redactor/store/StoreItemCluster";
import StoreItemSocial from "@/modules/redactor/store/StoreItemSocial";

import StoreTraderOrder from "@/modules/redactor/store/StoreTraderOrder";
import StoreTraderOffer from "@/modules/redactor/store/StoreTraderOffer";
import StoreTraderConfig from "@/modules/redactor/store/StoreTraderConfig";
import StoreDailyBonusConfig from "@/modules/redactor/store/StoreDailyBonusConfig";
import StoreDailyBonusTrack from "@/modules/redactor/store/StoreDailyBonusTrack";
import StoreDailyQuestConfig from "@/modules/redactor/store/StoreDailyQuestConfig";
import StoreDailyQuestOrder from "@/modules/redactor/store/StoreDailyQuestOrder";
import StoreBoatConfig from "@/modules/redactor/store/StoreBoatConfig";
import StoreBoatOrder from "@/modules/redactor/store/StoreBoatOrder";
import StoreSkyCommonConfig from "@/modules/redactor/store/StoreSkyCommonConfig";
import StoreSkySprintConfig from "@/modules/redactor/store/StoreSkySprintConfig";
import StoreLeagueConfig from "@/modules/redactor/store/StoreLeagueConfig";

import StoreProduct from "@/modules/redactor/store/StoreProduct";
import StoreProductGroup from "@/modules/redactor/store/StoreProductGroup";

import StoreAvatar from "@/modules/redactor/store/StoreAvatar";
import StoreBooster from "@/modules/redactor/store/StoreBooster";

import StoreMapAddon from "@/modules/redactor/store/StoreMapAddon";
import StoreMapAddonGroup from "@/modules/redactor/store/StoreMapAddonGroup";

import StoreCard from "@/modules/redactor/store/StoreCard";
import StoreCardPackage from "@/modules/redactor/store/StoreCardPackage";
import StoreCardCluster from "@/modules/redactor/store/StoreCardCluster";
import StoreMapKind from "@/modules/redactor/store/StoreMapKind";
import StoreMapGroup from "@/modules/redactor/store/StoreMapGroup";
import StoreWorkerKind from "@/modules/redactor/store/StoreWorkerKind";
import StoreAdEnergyRefill from "@/modules/redactor/store/StoreAdEnergyRefill";
import StoreAdPlacement from "@/modules/redactor/store/StoreAdPlacement";
import StoreAdUnit from "@/modules/redactor/store/StoreAdUnit";

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",

  state: {
    error: null,
    loading: false
  },
  getters: {},
  mutations: {
    setError(state, error) {
      state.error = error;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },
  actions: {
    init({dispatch}) {
      console.info('app initializing...')
      //dispatch('auth/init')
      dispatch('loadModule', MProfiles)
      dispatch('loadModule', MConfigs)
      dispatch('loadModule', MConfigEditor);
      dispatch('loadModule', MInbox);
      dispatch('loadModule', MLocalization);
      dispatch('loadModule', MPackages);
      dispatch('loadModule', Mmaps);
      dispatch('loadModule', Maudiences);
      dispatch('loadModule', Mdeploy);
      dispatch('loadModule', Mcache);
      dispatch('loadModule', Minfo);
      dispatch('loadModule', Mpermissions);
      dispatch('loadModule', Muiutils);
      dispatch('loadModule', Mutils);

      return dispatch('auth/init').then(() => {
        return Promise.resolve();
      });
    },

    // eslint-disable-next-line no-unused-vars
    loadModule: function ({dispatch}, module) {
      Store.registerModule(module.name, module.store)
      module.routes.forEach((route) => {
        Router.addRoute(route)
      })
    }
  },
  modules: {
    auth: Auth,

    [StoreAdPlacement.name]: StoreAdPlacement,
    [StoreAdUnit.name]: StoreAdUnit,

    [StoreAdEnergyRefill.name]: StoreAdEnergyRefill,
    [StoreChallenge.name]: StoreChallenge,
    [StoreSmartOffer.name]: StoreSmartOffer,
    [StoreWorkerTeam.name]: StoreWorkerTeam,
    [StoreWorldRegion.name]: StoreWorldRegion,
    [StoreWorldRegionTerritory.name]: StoreWorldRegionTerritory,
    [StoreSwamp.name]: StoreSwamp,
    [StoreTutorial.name]: StoreTutorial,
    [StoreCurrency.name]: StoreCurrency,
    [StoreCurrencyKind.name]: StoreCurrencyKind,
    [StoreCurrencyGroup.name]: StoreCurrencyGroup,
    [StoreDiscovery.name]: StoreDiscovery,
    [StoreExchange.name]: StoreExchange,
    [StorePrompt.name]: StorePrompt,
    [StoreFirefly.name]: StoreFirefly,
    [StoreFireflyV2.name]: StoreFireflyV2,
    [StoreSetting.name]: StoreSetting,

    [StoreProduct.name]: StoreProduct,
    [StoreProductGroup.name]: StoreProductGroup,

    [StoreReward.name]: StoreReward,
    [StoreRecipe.name]: StoreRecipe,
    [StoreLevel.name]: StoreLevel,
    [StoreMapGroup.name]: StoreMapGroup,
    [StoreMapKind.name]: StoreMapKind,
    [StoreWorkerKind.name]: StoreWorkerKind,

    [StoreTalk.name]: StoreTalk,
    [StoreQuest.name]: StoreQuest,

    [StoreCard.name]: StoreCard,
    [StoreCardCluster.name]: StoreCardCluster,
    [StoreCardPackage.name]: StoreCardPackage,

    [StoreItem.name]: StoreItem,
    [StoreItemKind.name]: StoreItemKind,
    [StoreItemGroup.name]: StoreItemGroup,
    [StoreItemShop.name]: StoreItemShop,
    [StoreItemAddon.name]: StoreItemAddon,
    [StoreItemOffer.name]: StoreItemOffer,
    [StoreItemOrder.name]: StoreItemOrder,
    [StoreItemRecipe.name]: StoreItemRecipe,
    [StoreItemSocial.name]: StoreItemSocial,
    [StoreItemCluster.name]: StoreItemCluster,

    [StoreBoatOrder.name]: StoreBoatOrder,
    [StoreBoatConfig.name]: StoreBoatConfig,

    [StoreTraderOrder.name]: StoreTraderOrder,
    [StoreTraderOffer.name]: StoreTraderOffer,
    [StoreTraderConfig.name]: StoreTraderConfig,

    [StoreDailyBonusTrack.name]: StoreDailyBonusTrack,
    [StoreDailyBonusConfig.name]: StoreDailyBonusConfig,

    [StoreDailyQuestOrder.name]: StoreDailyQuestOrder,
    [StoreDailyQuestConfig.name]: StoreDailyQuestConfig,

    [StoreLeagueConfig.name]: StoreLeagueConfig,
    [StoreSkySprintConfig.name]: StoreSkySprintConfig,
    [StoreSkyCommonConfig.name]: StoreSkyCommonConfig,

    [StoreAvatar.name]: StoreAvatar,
    [StoreBooster.name]: StoreBooster,

    [StoreMapAddon.name]: StoreMapAddon,
    [StoreMapAddonGroup.name]: StoreMapAddonGroup
  }
})

